<div #wrapper class="autocomplete-wrapper dropdown-wrapper" [class.slide-down] = "_isOpen">
    <div  class="dropdown-content" >
      <div #content class="dropdown-container">
        <ul class="items" aria-expanded="true" role="listbox" *ngIf = "_isOpen"  [id] = "id" #panel >
          <ng-content></ng-content>
        </ul>
      </div>
    </div>
</div>
